module.exports = __webpack_public_path__ + "img/Natalie.5a00e25f.jpg";